<!--
 * @Date: 2022-09-13 19:19:03
 * @LastEditTime: 2022-11-14 15:42:05
 * @Description: 青心计划 活动规则
-->
<template>
  <div class="activity-rule">
    <div class="rule-icon" @click="jumpToRules">
      <!-- <div class="rule-icon" @click="onClickRule"> -->
      <span>活</span>
      <span>动</span>
      <span>规</span>
      <span>则</span>
    </div>
    <div v-if="showRule" class="modal" @touchstart.self="onCloseRule">
      <div class="rule-wrapper">
        <div class="rule">
          <p class="title">活动规则</p>
          <p>一、活动规则</p>
          <p>
            1）本次金币活动时间：9月26日-10月10日，本次活动赚取的金币有效期是9月26日-10月15日;
          </p>
          <p>
            2）仅从此页面【任务栏】进入，点击完成相关任务才可获得相关金币奖励；如完成相关任务后删除，需扣除相应的金币；
          </p>
          <p>
            3）本次活动优先消耗活动期间赚到的金币，活动期间赚取的金币消耗完毕，会消耗日常赚取的金币；
          </p>
          <p>4）转盘抽奖每消耗100金币，可获得一次抽奖机会；</p>
          <p>
            5）抽中大转盘实物奖励需留下地址信息，方便发放奖品，实物奖品预计在15个工作日内寄出，
            活动期间不留下地址信息的视为放弃奖品；
          </p>
          <p>6）本活动解释权归春雨医生所有；</p>
          <p>7）如对本活动有疑问，请联系客服。</p>

          <p>二、详细规则</p>
          <p>1、树洞发帖1次奖励70金币，单日上限1次；</p>
          <p>2、树洞回帖1次奖励10金币，单日上限1次；</p>
          <p>3、完成心理测试1次奖励10金币，单日上限1次；</p>
          <p>4、转发心理测试1次奖励10金币，单日上限1次；</p>
          <p>5、预约直播1次奖励20金币，单日上限1次；</p>
          <p>
            6、观看直播1次奖励30金币，单日上限1次，且单次观看时间大于3分钟；
          </p>
          <p>7、直播评论1次奖励20金币，单日上限1次；</p>
          <p>8、发布自己故事1次奖励20金币，单日上限1次；</p>
          <p>9、查看科普1次奖励10金币，单日上限1次；</p>
        </div>
      </div>
      <img
        src="https://resource.chunyu.mobi/@/media/images/2022/09/19/ea4e/ac274df3bb38_w105_h102_.png"
        alt=""
        class="close-icon"
        @click="onCloseRule"
      />
    </div>
  </div>
</template>

<script>
import { doPoint } from '@/utils/index';
import * as cyDetect from '@cy/detect';

export default {
  props: {
    url: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showRule: false,
    };
  },
  methods: {
    jumpToRules() {
      if (this.url) {
        this.doPagePoint('AppClick', {
          page_readable_name: '运营活动',
          page_title: '金币任务页',
          click_position: '活动规则',
        }).finally(() => {
          window.location.href = this.url;
        });
      }
    },
    /**
     * 打开规则
     */
    onClickRule() {
      this.showRule = true;
      const ele = document.getElementsByClassName('qingxin-task')[0];
      ele.style.position = 'fixed';
      this.doPagePoint('AppClick', {
        page_readable_name: '运营活动',
        page_title: '金币任务页',
        click_position: '活动规则',
      });
    },
    /**
     * 关闭规则
     */
    onCloseRule() {
      const ele = document.getElementsByClassName('qingxin-task')[0];
      ele.style.position = 'relative';
      this.showRule = false;
    },
    /**
     * 打点函数
     *
     * @param type type
     * @param data 打点数据
     */
    doPagePoint(type, data) {
      let app;
      if (cyDetect.isFromCY()) {
        app = '0';
      } else if (cyDetect.isFromCYClinic()) {
        app = '1';
        // eslint-disable-next-line no-underscore-dangle
      } else if (window.__wxjs_environment === 'miniprogram') {
        app = 'weixin_mini';
      }
      return doPoint(type, {
        app,
        ...data,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.activity-rule {
  .rule-icon {
    position: absolute;
    top: rem(106);
    right: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    box-sizing: border-box;
    width: rem(24);
    height: rem(71);
    padding: rem(6) rem(7);
    color: #fff;
    font-weight: bold;
    font-size: rem(11);
    background: #ffa182;
    border-top-left-radius: rem(5);
    border-bottom-left-radius: rem(5);
  }
  .modal {
    position: fixed;
    top: 0;
    z-index: 2;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
  }
  .close-icon {
    position: absolute;
    top: rem(557);
    left: rem(169);
    width: rem(37);
    height: rem(37);
  }
  .rule-wrapper {
    position: absolute;
    top: rem(200);
    left: rem(48);
    box-sizing: border-box;
    width: rem(280);
    height: rem(342);
    padding: rem(20) rem(24);
    background: #fff;
    border-radius: rem(4);
    .rule {
      height: 100%;
      overflow: scroll;
      line-height: rem(25);
    }
    .title {
      margin-bottom: rem(12);
      color: #1a1a1a;
      font-size: rem(18);
      text-align: center;
    }
    p {
      margin: 0;
      color: #666;
      font-size: rem(15);
    }
  }
}
</style>
